import React from 'react';
import useDataService from '../../hooks/useDataService';
import { eMessageType } from '../../types/IMessageType';
import { manualSchemaUploadV3 } from '../SchemaSync/ManualUploadV3';
import { checkForSuccesInvocation } from '../../_lib/utils';
import { useConfirm } from '../../context/ConfirmContext';

export interface IUseSchemaUploadV3Props {
  syncFor: string;
  messagesSet: any;
}

export const useSchemaUploadV3 = ({ syncFor, messagesSet }: IUseSchemaUploadV3Props) => {
  const { confirm } = useConfirm();
  const [fileState, setFileState] = React.useState<any>(null);
  const [release, setRelease] = React.useState('');
  const [type, setType] = React.useState('');
  const [tenantId, setTenantId] = React.useState('');
  const [processState, setProcessState] = React.useState<number>(0);
  const [previewState, setPreviewState] = React.useState<any>(null);
  const { openSnackBar } = useDataService();

  const setFile = (file: any) => setFileState(file[0]);

  const restart = () => {
    setProcessState(0);
    setFileState(null);
    setPreviewState(null);
    setRelease('');
    setType('');
    setTenantId('');
  };

  const upload = () => {
    if (!fileState) return alert('Please choose a file');
    if (processState !== 0) return alert('Upload already in progress. Please wait!');

    setProcessState(1);
    manualSchemaUploadV3(fileState, release, syncFor, type, tenantId).then(async (data: any) => {
      if (!data.error) {
        try {
          checkForSuccesInvocation(data, setPreviewState, setProcessState);
        } catch (e: any) {
          openSnackBar(e.message || 'Something went wrong,Unable to check status', eMessageType.error);
        }
      } else {
        openSnackBar('Something went wrong', eMessageType.error);
        messagesSet(true, 'Error on server!');
        restart();
      }
    });
  };

  const handleUploadClick = () => confirm({ onConfirm: upload });

  return {
    fileState,
    setFile,
    release,
    setRelease,
    type,
    setType,
    tenantId,
    setTenantId,
    processState,
    previewState,
    restart,
    handleUploadClick,
  };
};
